import { gql } from '@apollo/client';
import { useEffect } from 'react';
import { graphql } from '@xolv-mybrightlink/common';
import { useCareTeam } from './useCareTeam';

type PatientResponse = {
  listUserPatients: {
    guid: string;
    firstName?: string;
    lastName?: string;
  }[];
};

export const useFetchPatients = () => {
  const [store, dispatch] = useCareTeam();
  const isLoading = store === 'LOADING';
  useEffect(() => {
    const fetch = async () => {
      if (isLoading) {
        return;
      }
      const query = gql`
        query patientListWithTreatmentPlanAndGoals {
          listUserPatients {
            guid
            firstName
            lastName
          }
        }
      `;
      const { data } = await graphql.query<PatientResponse>({ query });
      dispatch({ type: 'PATIENT_UPDATE', patients: data.listUserPatients });
    };
    fetch();
  }, [isLoading, dispatch]);
};
